import { SvgBase } from "../svg.base";

export const QualityLock = () => (
    <SvgBase
        width="16"
        height="16"
        viewBox="0 0 16 16"
    >
        <g fill="none" fillRule="evenodd">
            <g fill="currentColor" fillRule="nonzero">
                <g>
                    <g>
                        <path d="M8.336 1.333c2.095.001 3.807 1.514 3.915 3.416l.005.192v1.392h.29c.755 0 1.377.508 1.447 1.157l.007.123v5.774c0 .707-.65 1.28-1.453 1.28H4.12c-.802 0-1.453-.573-1.453-1.28V7.613c0-.707.65-1.28 1.453-1.28h.29V4.941c0-1.993 1.757-3.608 3.926-3.608zm4.21 5.91H4.12c-.232 0-.42.166-.42.37v5.774c0 .204.188.37.42.37h8.427c.232 0 .42-.166.42-.37V7.613c0-.204-.188-.37-.42-.37zM8.398 9.667c.246 0 .45.157.492.364l.008.08v1.611c0 .246-.223.445-.5.445-.245 0-.45-.158-.492-.365l-.008-.08v-1.611c0-.245.224-.444.5-.444zm-.062-7.351c-1.517 0-2.758 1.086-2.85 2.459l-.006.166-.001 1.392h5.71V4.941c0-1.45-1.278-2.625-2.853-2.625z" transform="translate(-81 -213) translate(81 212) translate(0 1)" />
                    </g>
                </g>
            </g>
        </g>
    </SvgBase>
);